import React from "react";
import "../../styles/Accordion.css"
import AllertIscrizione from "../multitessere/AllertIscrizione";

function FitAccordionPrezzi() {
    return (
        <div className="accordion d-flex flex-column m-auto" id="accordionFlushExample" style={{maxWidth: "50em"}}>
            <div className="accordion-item">
                <h2 className="accordion-header d-flex flex-row" id="headingOne"
                    style={{justifyContent: "center", textAlign: "center"}}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        PREZZI
                    </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                     data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{width: "40em"}}>
                                <thead >
                                <tr >
                                    <th scope="col" ></th>
                                    <th scope="col" style={{width: "15%"}}>
                                        3 mesi
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        6 mesi
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        stagionale
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">Monosettimanale</th>
                                    <td className={"data-cell"}>165€</td>
                                    <td className={"data-cell"}>258€</td>
                                    <td className={"data-cell"}>362€</td>
                                </tr>
                                <tr>
                                    <th scope="row">Bisettimanale<br/> <span style={{fontSize: "12px"}}>(fino alle 16)</span></th>
                                    <td className={"data-cell"}>238€</td>
                                    <td className={"data-cell"}>369€</td>
                                    <td className={"data-cell"}>488€</td>
                                </tr>
                                </tbody>
                            </table>
                            <br/>
                            <br/>
                        </div>
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{width: "30em"}}>
                                <thead >
                                <tr >
                                    <th scope="col" ></th>
                                    <th scope="col" style={{width: "30%"}}>
                                        Lezione di prova
                                    </th>
                                    <th scope="col" style={{width: "30%"}}>
                                        11 ingressi
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">Ingressi</th>
                                    <td className={"data-cell"}>15€</td>
                                    <td className={"data-cell"}>110€</td>
                                </tr>
                                </tbody>
                            </table>
                            <br/>
                            <AllertIscrizione />
                            <br/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FitAccordionPrezzi